import script from "./AboutUs.vue?vue&type=script&lang=ts&setup=true"
export * from "./AboutUs.vue?vue&type=script&lang=ts&setup=true"

import "./AboutUs.vue?vue&type=style&index=0&id=32799242&scoped=true&lang=css"
import "./AboutUs.vue?vue&type=style&index=1&id=32799242&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32799242"]])

export default __exports__